<template>
    <div style="position: relative;">
        <img src="@/assets/images/strategy/background.png" alt class="bg1"/>
        <div class="topBlock">
            <div class="line"></div>
            <div 
                v-for="(item, ind) in btnGrounps"
                :key="ind"
                @click="btnChange(ind, item)"
                style="z-index: 99;">
                <div class="btnBlock" :class="{ active: btnActive == ind }">{{item.title}}</div>
            </div>
        </div>

            <div class="cont" v-loading="dataLoading">
            <div style="display: flex;justify-content: space-evenly;">
                <div>
                    <div class="title">
                        <img :src="targetTitle[btnActive]" alt class="titleImg" />
                        <div class="greyTips">
                            <el-popover
                                placement="top"
                                width="100%"
                                trigger="hover"
                                style="font-size:0"
                                :content="tips[btnActive].tip">
                                <img slot="reference" src="@/assets/images/strategy/greyTips.png" alt style="width: 20px;" />
                            </el-popover>
                        </div>
                    </div>
                    <div class="targetBg">
                        <div class="target">
                            <div class="targetItem" v-for="(item,int) in targetData" :key="int">
                                <div style="margin: 20px 30px;width: 150px;">
                                    <div class="num">{{ item.num }} <span v-if="int == 2 || int == 3">%</span></div>
                                    <div class="name">{{ item.title }}</div>
                                </div>
                                <div><img :src="item.icon" alt class="iconImg" /></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="guidance">
                    <div class="tips" v-if="nowStatus == 1">
                        <div class="tipsIcon"><img src="@/assets/images/strategy/redTips.png" alt class="tipsImg" /></div>
                        <div class="tipsCont">芜湖~emo了，店铺{{statusTitle}}<span style="color: #FE4D45;">异常</span>，<span v-if="btnActive == 0 || btnActive == 1">上次达标的时候还是上次，</span>尽快完成以下策略</div>
                    </div>
                    <div class="tips" v-if="nowStatus == 2">
                        <div class="tipsIcon"><img src="@/assets/images/strategy/greenTips.png" alt class="tipsImg" /></div>
                        <div class="tipsCont">破防了，店铺{{statusTitle}}<span style="color: #00BE90;">还不错</span>，拒绝躺平，内卷起来！完成以下策略</div>
                    </div>
                    <div class="tips" v-if="nowStatus == 3">
                        <div class="tipsIcon"><img src="@/assets/images/strategy/greenTips.png" alt class="tipsImg" /></div>
                        <div class="tipsCont">恭喜！店铺{{statusTitle}}达到<span style="color: #00BE90;">优秀</span>啦，来~继续保持，看看以下策略</div>
                    </div>
                    <div class="guidanceBg"><img src="@/assets/images/strategy/guidanceBg.png" alt class="guidanceImg" /></div>
                </div>
            </div>
            </div>
            <div style="position: relative;"  class="Operat" v-loading="operatLoading">
                <img src="@/assets/images/strategy/background.png" alt class="bg2"/>
                <div class="cont">
                    <div class="title" style="margin: 60px 0 0 0;">
                        <img src="@/assets/images/strategy/OperationaTitle.png" alt class="titleImg" />
                    </div>
                    <div class="OperationaBox">
                        <div class="Operationa">
                            <template v-for="(item,int) in OperationaList"  >
                                <div v-if="item.strategyType == btnActive+1" class="OperationaItem" :key="int">
                                <div class="mr_tips" v-if="item.tagUrl"><img :src="item.tagUrl" alt class="mr_tipsIcon" /></div>
                                <div class="mr_icon" ><img :src="operationIcon[item.type-1]" alt class="mr_iconImg" /></div>
                                <div class="operationaTitleBg"><div class="operationaTitle">{{ item.name }}</div></div>
                                <div class="operationaDesc">{{ item.description }}</div>
                                <div v-if="item.isNeedUpgrade" class="btns" style="justify-content: center">
                                    <div class="button_2" @click="routerLink(item,'https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch')">立即升级</div>
                                </div>
                                <div class="btns" :style="item.isHaveCase==1?'justify-content: space-between;':'justify-content: center'" v-else>
                                    <!-- 图片 -->
                                    <div v-if="item.isHaveCase  == 1 && item.caseShowType ==1">
                                        <!-- 提示框形式 -->
                                        <!-- <el-popover
                                            placement="top"
                                            width="100%"
                                            trigger="click"
                                            style="font-size:0"
                                            >
                                            <div>
                                                <img slot="reference" :src="item.caseShowPicUrl" alt  />
                                            </div>
                                            <div class="button_1"  slot="reference" >{{ item.caseText}}</div>
                                        </el-popover> -->
                                        <!-- 弹窗形式 -->
                                        <!-- <div class="button_1" @click="openImg(item.caseShowPicUrl)">{{ item.caseText}}</div> -->
                                        <!-- 图片预览模式 -->
                                        <div class="button_1" @click="onPreview(item.caseShowPicUrl)">{{ item.caseText}}</div>
                                    </div>
                                    <!-- 跳转 -->
                                    <div class="button_1" v-if="item.isHaveCase  == 1 && item.caseShowType ==2" @click="routerLink(item,item.caseShowLink,1)">{{ item.caseText}}</div>
                                    <div class="button_2" @click="routerLink(item,item.jumpLink,2)">{{ item.jumpText}}</div>
                                </div>
                            </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        
        <el-dialog
        v-if="imgVisible"
        :visible.sync="imgVisible"
        :close-on-click-modal="false"
        >
        <div style="text-align: center;">
            <img class="imgVisibleUrl" :src="imgVisibleUrl" alt  />
        </div>
        </el-dialog>

        <!-- 图片预览 不能放for循环里面 -->
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="urlLists" />

        
    </div>
</template>

<script>
import {
	operationData,operationList,getClickData,getSeller,toJHK
} from "@/api/industry/strategy.js";
import TemplateDialog from '../../../components/template-dialog.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {
  getOfficialmemberCrowd
} from "@/api/manage/memberCrowdController";

export default {
name: '' ,
components: {TemplateDialog,ElImageViewer},
props:{
    isData:{
        type:Object
    }
},
data() {
return {
    btnGrounps:[
        {
            title:'首购转化'
        },
        {
            title:'老客招募'  
        },
        {
            title:'复购召回'  
        },
        {
            title:'流失激活'  
        }
    ],
    dataLoading:false,
    operatLoading:false,
    btnActive:0,
    nowStatus:1,
    statusTitle:'新会员首购',
    targetTitle:[
        require('@/assets/images/strategy/FirstPurchaseTitle.png'),
        require('@/assets/images/strategy/OldCustomerTitle.png'),
        require('@/assets/images/strategy/RepurchaseTitle.png'),
        require('@/assets/images/strategy/LossTitle.png')
    ],
    tips:[
        {tip:'新会员首购率=当月新会员购买客户数/当月新入会总数*100%'},
        {tip:'已购会员占比=已购会员数/成交客户数*100%'},
        {tip:'近90天复购率=近90天购买次数大于1/近90天成交客户数*100%'},
        {tip:'流失客户占比=近1年未购的已购客户数/历史成交总客户数*100%'}
    ],
    operationIcon:[
        require('@/assets/images/strategy/mr_icon.png'),
        require('@/assets/images/strategy/ydx.png'),  
        require('@/assets/images/strategy/jhk.png'),
        require('@/assets/images/strategy/gf.png'),
    ],
    targetData:[],
    FirstPurchaseStatus:1,
    OldCustomerStatus:1,
    RepurchaseStatus:1,
    LossStatus:1,
    FirstPurchase:[
        {
            icon:require('@/assets/images/strategy/icon1.png'),
            title:'当月新会员购买客户数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon2.png'),
            title:'当月新会员数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon3.png'),
            title:'新会员首购率',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon4.png'),
            title:'目标完成进度',
            num:256598,
        }
    ],
    OldCustomer:[
        {
            icon:require('@/assets/images/strategy/icon1.png'),
            title:'已购会员数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon2.png'),
            title:'成交客户数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon3.png'),
            title:'已购会员占比',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon4.png'),
            title:'目标完成进度',
            num:256598,
        }
    ],
    Repurchase:[
        {
            icon:require('@/assets/images/strategy/icon1.png'),
            title:'近90天复购客户数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon2.png'),
            title:'近90天成交客户数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon3.png'),
            title:'近90天复购率',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon4.png'),
            title:'目标完成进度',
            num:256598,
        }
    ],
    Loss:[
        {
            icon:require('@/assets/images/strategy/icon1.png'),
            title:'流失客户数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon2.png'),
            title:'历史成交总客户数',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon3.png'),
            title:'流失客户占比',
            num:256598,
        },
        {
            icon:require('@/assets/images/strategy/icon4.png'),
            title:'目标完成进度',
            num:256598,
        }
    ],
    OperationaList:[],
    imgVisible:false,
    imgVisibleUrl:'',
    showViewer: false, // 显示查看器
    urlLists:[],//查看图片
    isOrderHd:false,//京获客资格
}
},
computed: {},
watch:{
    isData: {
      handler(newName, oldName) {
        this.getOperationData() 
      },
    },
},
created() {

},
mounted() {
    this.getOperationData()
    // this.getOperationList()
    this.getMemberCrowd()
    this.getSellers()
},
methods: {
    //获取京获客资格
    getSellers(){
        getSeller().then(res => {
            if (res.code == 1) {
                this.isOrderHd = res.data.isOrderHd
            }else{
                this.$message.warning(res.message)
            }
        })
    },
    //获取诊断数据
    getOperationData(){
        this.dataLoading = true
        operationData().then((res) => {
            if(res.code === 1){

                this.FirstPurchase[0].num=res.data.newMemberBuyNum
                this.FirstPurchase[1].num=res.data.newMemberNum
                this.FirstPurchase[2].num=res.data.newMemberFirstBuyRate
                this.FirstPurchase[3].num=res.data.firstBuySchedule
                this.FirstPurchaseStatus=res.data.firstDiagnosisStatus

                this.OldCustomer[0].num=res.data.purchasedMemberNum
                this.OldCustomer[1].num=res.data.buyerNum
                this.OldCustomer[2].num=res.data.purchasedMemberBuyRate
                this.OldCustomer[3].num=res.data.oldSchedule
                this.OldCustomerStatus= res.data.purchasedDiagnosisStatus

                this.Repurchase[0].num=res.data.purchasedMember90Num
                this.Repurchase[1].num=res.data.buyer90Num
                this.Repurchase[2].num=res.data.purchased90Rate
                this.Repurchase[3].num=res.data.purSchedule
                this.RepurchaseStatus=res.data.purchased90DiagnosisStatus

                this.Loss[0].num=res.data.lossNum
                this.Loss[1].num=res.data.buyerNum
                this.Loss[2].num=res.data.lossRate
                this.Loss[3].num=res.data.lossSchedule
                this.LossStatus=res.data.lossDiagnosisStatus
            
                this.btnChange(0)
            }else{
                this.$message.warning(res.message);
            }
            this.dataLoading=false
      });  
    },
    //获取行业策略列表
    getOperationList(){
        this.operatLoading=true
        operationList().then((res)=>{
            this.operatLoading=false
            if(res.code === 1){
                this.OperationaList= res.data
            }else{
                this.$message.warning(res.message); 
            }
        })
    },
    //获取人群
    getMemberCrowd(){
        const params = { sysType: '' };
        getOfficialmemberCrowd(params).then(res => {
        if (res.data && res.code == 1) {
            this.getOperationList()
        }
      });
    },
    //切换
    btnChange(ind, item){
        this.btnActive = ind;
        if(this.btnActive === 0){
            this.targetData=this.FirstPurchase
            this.nowStatus=this.FirstPurchaseStatus
            if(this.nowStatus == 1){
                this.statusTitle='新会员首购转化'
            }else if(this.nowStatus == 2){
                this.statusTitle='新会员首购率'
            }else{
                this.statusTitle='新会员首购'
            }
            
        }else if(this.btnActive === 1){
            this.targetData=this.OldCustomer
            this.nowStatus=this.OldCustomerStatus
           
            if(this.nowStatus == 1){
                this.statusTitle='会员规模'
            }else if(this.nowStatus == 2){
                this.statusTitle='会员转化'
            }else{
                this.statusTitle='会员转化'
            }
        }
        else if(this.btnActive === 2){
            this.targetData=this.Repurchase
            this.nowStatus=this.RepurchaseStatus
            
            if(this.nowStatus == 1){
                this.statusTitle='存量客户'
            }else if(this.nowStatus == 2){
                this.statusTitle='客户复购'
            }else{
                this.statusTitle='客户复购'
            }
        }
        else if(this.btnActive === 3){
            this.targetData=this.Loss
            this.nowStatus=this.LossStatus
            
            if(this.nowStatus == 1){
                this.statusTitle='客户流失'
            }else if(this.nowStatus == 2){
                this.statusTitle='客户留存'
            }else{
                this.statusTitle='客户留存'
            }
        }
    },
    //4. 获取点击次数
    getClickNum(id) {
      let params = {
        type: 1,
        industryId: id
      };
      getClickData(params)
        .then(res => {})
        .catch(() => {});
    },
    //打开图片弹窗
    openImg(url){
        this.imgVisibleUrl=url
        this.imgVisible = true
    },
    onPreview(url) {
        this.urlLists = [url]
        this.showViewer = true
    },
    // 关闭查看器
    closeViewer() {
        this.showViewer = false
    },
    //跳转
    routerLink(item,link,type) {
        console.log("item",item,link,type)
        this.getClickNum(item.id)

        if(item.type == 1 && type == 2){
            console.log("人群id",item.precisionCrowdStrategyId)
            let routeUrl = this.$router.resolve({
                path: "/marketing/marketing/accurate_market",
                query:{
                    precisionCrowdStrategyId:item.precisionCrowdStrategyId
                }
            });
            window.open(routeUrl.href, "_blank");
        }else if(item.type == 3){
            if(this.isOrderHd){
                //跳转到jhk
                let jhkLine = link +'&activityType='+item.activityType
                toJHK({url:jhkLine}).then(res => {
                    if (res.code == 1) {
                        let jhk_link = res.data
                        window.open(jhk_link, "_blank");
                    }else{
                        this.$message.warning(res.message)
                    }
                })
            }else{
                //没有买jhk或者过期
                window.open("/jhkGuide", "_blank");
                // this.buriedPoint(1, "引导订购京获客页面", "行业专区", "行业运营策略");
            }
        }else{
            if(link){
                let _link =link
                if ( _link.substr(0, 7).toLowerCase() == 'http://' || _link.substr(0, 8).toLowerCase() == 'https://' ) {

                } else {
                    _link = 'https://' + _link
                }
                window.open(_link, "_blank");
            }else{
                console.log("link",link)
            }
        }
    },
}
}
</script>
<style lang='scss'>
.cont,.Operat{
    .el-loading-spinner .path{
        stroke: #6461E7 !important;
    }
}
</style>
<style lang='scss' scoped>
.bg1{
    position: absolute;
    top: -40px;
    right: 100px;
    width: 426px;
    height: 434px;
}
.bg2{
    position: absolute;
    left: 0px;
    width: 426px;
    height: 434px;
}
.topBlock{
    position: relative;
    width: 900px;
    margin: 50px auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .btnBlock{
    width: 120px;
    height: 35px;
    line-height: 35px;
    opacity: 1;
    border: 1px solid #6461E7;
    border-radius: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #6461E7;
    text-align: center;
    background: #FFFFFF;
    cursor: pointer;
    }
    .btnBlock.active{
        background: #6461E7;
        color: #FFFFFF;
    }
    .line{
        width: 697px;
        // border-bottom: 1px dashed #A194FF;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 1px;
        background-image: linear-gradient(to left, #A194FF 0%, #A194FF 80%, transparent 50%);
        background-size: 10px 100%;
        background-repeat: repeat-x;
    }
}
.cont{
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .title{
        width: 600px;
        margin-bottom: 30px;
        position: relative;
        .titleImg{
            width:100%;
        }
        .greyTips{
            position: absolute;
            top: 20px;
            left: 180px;
        }
    }
    .tips{
        display: flex;
        position: absolute;
        top: 50px;
        left: 50px;
        .tipsIcon{
            width: 14px;
            margin-right: 5px;
            .tipsImg{
                width: 100%;
            }
        }
        .tipsCont{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            width: 156px;
            line-height: 16px;
        }
    }
    .guidance{
        position: relative;
        .guidanceBg{
            width: 513.1px;
            .guidanceImg{
                width: 100%;
            }
        }
    }
    .targetBg{
        background: linear-gradient(90deg, #E4E5FF 0%, rgba(229,229,255,0) 82%);
        border-radius: 16px 16px 16px 16px;
        padding: 20px 20px 8px 20px;
    }
    .target{
        display: flex;
        flex-wrap: wrap;
        .targetItem{
            background: #FFFFFF;
            border-radius: 12px 12px 12px 12px;
            width: 300px;
            height: 98px;
            margin: 0 20px 12px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .num{
                font-size: 24px;
                font-weight: bold;
                color: #4936BB;
            }
            .name{
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                margin-top: 8px;
            }
            .iconImg{
                width:98px
            }
        }
    }
    .mr_icon{
        text-align: center;
        margin: 50px 30px 30px 30px;
        .mr_iconImg{
            width: 80px;
        }
    }
    .OperationaBox{
        .Operationa{
            display: flex;
            flex-wrap: wrap;
            width: 1200px;
            .OperationaItem{
                width: 285px;
                background: #FFFFFF;
                border-radius: 16px 16px 16px 16px;
                opacity: 1;
                border: 1px solid #F5F3FF;
                text-align: center;
                margin: 30px 10px 0 10px;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
                .operationaTitleBg{
                    display: inline-block;
                    position: relative;
                    .operationaTitle{
                        font-size: 20px;
                        font-weight: bold;
                        color: #333333;
                        display: inline-block;
                        position: relative;
                        z-index: 99;
                    }
                }
                .mr_tips{
                    height: 32px;
                    float: right;
                    .mr_tipsIcon{
                        width: 100%;
                        height: 100%;
                    }
                }
               
                .operationaTitle::before{
                    content: "";
                    position: absolute;
                    left: 50%;
                    bottom: -4px;
                    -webkit-transform: translate(-50%, 0);
                    transform: translate(-50%, 0);
                    height: 8px;
                    background: #E4E5FF;
                    border-radius: 4px;
                    width: 100%;
                    z-index: -99;
                }
                .operationaDesc{
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    overflow:hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 3;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    padding: 0 30px 0 30px;
                    margin: 20px 0 30px 0;
                    text-align: left;
                    // line-height: 16px;
                    line-height: 20px;
                    height: 60px;
                }
                .btns{
                    display: flex;
                    align-items: center;
                    margin: 0 30px 30px 30px ;
                    .button_1{
                        width: 106px;
                        height: 32px;
                        line-height: 32px !important;
                        background: #FFFFFF;
                        border-radius: 19px 19px 19px 19px;
                        opacity: 1;
                        border: 1px solid #D8D7E1;
                        font-size: 14px;
                        font-weight: 400;
                        color: #85819A;
                        line-height: 16px;
                        cursor: pointer;
                    }
                    .button_1:hover,.button_1:focus{
                        background: #EDEDFF;
                        border-color: #EDEDFF;
                        color: #6461E7;
                    }
                    .button_2{
                        width: 106px;
                        height: 32px;
                        line-height: 32px;
                        background: #FFFFFF;
                        border-radius: 19px 19px 19px 19px;
                        opacity: 1;
                        border: 1px solid #6461E7;
                        font-size: 14px;
                        font-weight: 400;
                        color: #6461E7;
                        cursor: pointer;
                    }
                    
                    .button_2:hover,.button_2:focus{
                        background: #6461E7;             
                        color: #FFFFFF;
                    }
                }
            }
            .OperationaItem:first-child{
                margin-left: 0;
            }
            .OperationaItem:nth-child(4n){
                margin-right: 0;
            }
            .OperationaItem:nth-child(4n+1){
                margin-left: 0;
            }
            .OperationaItem:hover,.OperationaItem:focus{
                -webkit-box-shadow:  0px 0px 30px 0px rgba(100,97,231,0.15);
                box-shadow:  0px 0px 30px 0px rgba(100,97,231,0.15);
                -webkit-transform: translate(0, -12px);
                transform: translate(0, -12px);
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
            }
        }
    }
    
}

</style>